import React from 'react';
import { Button, Modal, Spin, Tag } from 'antd';
import styled from 'styled-components';
import CreativeTypeForm from '../../molecules/CreativeTypeForm';
import OptionalFields from '../../molecules/OptionalFields';

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const WrappedField = styled.div`
  .ant-form-item-label {
    white-space: pre-wrap;
  }
`;

const CreativeFormModal = ({
  lineItemId,
  isEdit,
  handleSubmit,
  submitting,
  activeCreative,
  visible,
  showE2PreviewModal,
  onCancel,
  loading,
}) => (
  <Modal
    zIndex={1002}
    destroyOnClose
    confirmLoading={submitting}
    onCancel={onCancel}
    onOk={handleSubmit}
    width={900}
    okText={isEdit ? 'Update' : 'Create'}
    title={
      <span>
        {isEdit ? 'Edit' : 'New'} Creative{' '}
        {activeCreative.creative_service_id && <Tag>ID {activeCreative.creative_service_id}</Tag>}
        <Button type="link" onClick={showE2PreviewModal}>
          Preview Creative
        </Button>
      </span>
    }
    visible={visible}
  >
    <Spin spinning={loading}>
      <form onSubmit={handleSubmit}>
        <WrappedField>
          <CreativeTypeForm
            lineItemId={lineItemId}
            activeCreative={activeCreative}
            formItemLayout={formItemLayout}
          />
        </WrappedField>
        <OptionalFields formItemLayout={formItemLayout} />
      </form>
    </Spin>
  </Modal>
);

export default CreativeFormModal;
